/* istanbul ignore file */
export * from './CategoryPageDefaultContent';
